<template>
  <div class="min-vh main-theme">
    <div class="p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "EDIT" : "CREATE" }} ASSIGN BY TEAM
      </h1>
    </div>
    <div class="mt-3 bg-white-border p-3" v-if="!isLoading">
      <b-row>
        <b-col cols="12">
          <InputText
            textFloat="Name"
            placeholder="Name"
            type="text"
            name="assign_by_team_name"
            v-model="form.name"
            isRequired
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
            class="mb-0"
          />
        </b-col>
      </b-row>
      <div class="mt-3 border" v-if="form.id > 0">
        <div class="p-3 bgc-second">
          <span class="unit-font text-break">Agent List</span>
        </div>
        <div class="p-3">
          <button class="create-button mb-3" @click="openModalAgent(2)">
            <font-awesome-icon icon="plus-square" />
            <span class="ml-2"> Add Agent</span>
          </button>
          <b-table
            responsive
            striped
            hover
            class="table-list"
            :items="agent.items"
            :fields="agent.fields"
            :busy="agent.isBusy"
            show-empty
            :empty-text="$t('noData')"
          >
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(id)="data">
              <div class="d-flex justify-content-center">
                <b-link
                  class="text-link ml-3"
                  @click="onDeleteModalAgent(data.item)"
                >
                  <font-awesome-icon
                    icon="trash-alt"
                    class="text-danger"
                    title="Delete"
                  />
                </b-link>
              </div>
            </template>
          </b-table>
          <!-- <span class="text-error" v-if="$v.agent.items.$error"
            >กรุณากรอกข้อมูล</span
          > -->
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="form-inline justify-content-end justify-content-sm-end"
            >
              <div class="d-sm-flex mx-3">
                <b-pagination
                  v-model="agent.filter.pageNo"
                  :total-rows="agent.rows"
                  :per-page="agent.filter.perPage"
                  class="m-md-0"
                  @change="paginationAgent"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="mt-3 border" v-if="form.id > 0">
        <div class="p-3 bgc-second">
          <span class="unit-font text-break">Channel</span>
        </div>
        <div class="p-3">
          <button class="create-button mb-3" @click="openModalChannel">
            <font-awesome-icon icon="plus-square" />
            <span class="ml-2"> Add Channel</span>
          </button>
          <b-table
            responsive
            striped
            hover
            class="table-list"
            :items="channel.items"
            :fields="channel.fields"
            :busy="channel.isBusy"
            show-empty
            :empty-text="$t('noData')"
          >
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(platformconfigId)="data">
            <div class="tag-social">
              <img :src="data.item.iconUrl" alt="" />
              <span class="mb-0">{{ data.item.platformName }}</span>
            </div>
            </template>
            <template v-slot:cell(id)="data">
              <div class="d-flex justify-content-center">
                <b-link
                  class="text-link ml-3"
                  @click="onDeleteModalChannel(data.item)"
                >
                  <font-awesome-icon
                    icon="trash-alt"
                    class="text-danger"
                    title="Delete"
                  />
                </b-link>
              </div>
            </template>
          </b-table>
          <span class="text-error" v-if="$v.channel.items.$error"
            >กรุณากรอกข้อมูล</span
          >
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="form-inline justify-content-end justify-content-sm-end pb-0"
            >
              <div class="d-sm-flex mx-3">
                <b-pagination
                  v-model="channel.filter.pageNo"
                  :total-rows="channel.rows"
                  :per-page="channel.filter.perPage"
                  class="m-md-0"
                  @change="pagination"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/assign-by-team">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5"
              >CANCEL</b-button
            >
          </router-link>
        </b-col>
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="onSubmit"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            {{ this.form.id ? "SAVE" : "CONTINUE" }}
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalUser ref="ModalUser" :id="form.id" @reloadData="reloadDataAgent" />
    <ModalChannel
      :id="form.id"
      ref="ModalChannel"
      @reloadData="reloadDataChannel"
    />
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalUser from "./components/ModalUser.vue";
import ModalChannel from "./components/ModalChannel.vue";

import { required, url, minValue, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SettingTime",
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    ModalAlertConfirm,
    ModalUser,
    ModalChannel,
  },
  validations() {
    return {
      form: {
        name: { required },
      },
      channel: {
        items: { required },
      },
      // agent : {
      //   items: { required },
      // }
    };
  },
  data: function () {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        teamAutoAssignId: "",
        userId: "",
        platformconfigId: "",
      },
      isDisabled: false,
      isLoading: true,
      id: this.$route.params.id,
      roleId: "",
      agent: {
        fields: [
          {
            key: "name",
            label: "Name",
            class: "w-100px",
            tdClass: "text-center",
          },
          {
            key: "email",
            label: "Email",
            class: "w-100px",
            tdClass: "text-center",
          },
          {
            key: "role",
            label: "Role",
            class: "w-100px",
            tdClass: "text-center",
          },
          {
            key: "id",
            label: "",
            class: "w-action",
          },
        ],
        filter: {
          search: "",
          pageNo: 1,
          perPage: 10,
        },
        items: [],
        rows: 0,
        isBusy: false,
      },
      channel: {
        fields: [
          {
            key: "name",
            label: "Channel Name",
            class: "w-100px",
            tdClass: "text-center",
          },
          {
            key: "platformconfigId",
            label: "Platform",
            tdClass: "text-center",
          },
          {
            key: "id",
            label: "",
            class: "w-action",
          },
        ],
        items: [],
        isBusy: false,
        rows: 0,
        filter: {
          search: "",
          pageNo: 1,
          perPage: 10,
        },
      },
      form: {
        brandID: parseInt(this.$store.getters.getCurrentBrandID()),
      },
      flag: null,
    };
  },
  created: async function () {
    this.isLoading = true;
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    this.$v.$reset();

    if (this.id) {
      await this.getDetail();
      await this.getListAgent();
      await this.getListChannel();
    }
    this.isLoading = false;
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    pagination(Page) {
      this.channel.filter.pageNo = Page;
      this.getListChannel();
    },
    paginationAgent(Page) {
      this.agent.filter.pageNo = Page;
      this.getListAgent();
    },
    async openModalAgent(roleId) {
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      this.roleId = roleId;
      setTimeout(async () => {
        await this.$store.commit("UPDATE_MAIN_LOADING", false);
        await this.$refs.ModalUser.onShowModal();
      }, 100);
    },
    async openModalChannel() {
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
      await this.$refs.ModalChannel.onShowModal();
    },
    async reloadDataAgent() {
      this.agent.isBusy = true;
      await this.getListAgent();
      this.agent.isBusy = false;
    },
    async reloadDataChannel() {
      this.channel.isBusy = true;
      await this.getListChannel();
      this.channel.isBusy = false;
    },
    getDetail: async function () {
      await this.axios
        .post(`${this.$baseUrl}/TeamAssign/GetDetail/${this.id}`, {})
        .then((data) => {
          if (data.result == 1) {
            this.form = data.detail;
          }
        });
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      let path = "";
      if (this.flag == "channel") {
        path = `TeamAssign/DeleteChannel/${this.bodyDelete.platformconfigId}/${this.bodyDelete.teamAutoAssignId}`;
      } else
        path = `TeamAssign/DeleteAgent/${this.bodyDelete.userId}/${this.bodyDelete.teamAutoAssignId}`;

      await this.axios
        .delete(`${this.$baseUrl}/${path}`)
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            if (this.flag == "channel") await this.getListChannel();
            else await this.getListAgent();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    getListChannel: async function () {
      await this.axios
        .post(
          `${this.$baseUrl}/TeamAssign/GetDetailChannel/${this.id}`,
          this.channel.filter
        )
        .then((data) => {
          if (data.result == 1) {
            this.channel.items = data.detail.channels;
            this.channel.rows = data.detail.count;
          }
        });
    },
    getListAgent: async function () {
      await this.axios
        .post(
          `${this.$baseUrl}/TeamAssign/GetDetailAgent/${this.id}`,
          this.agent.filter
        )
        .then((data) => {
          if (data.result == 1) {
            this.agent.items = data.detail.userList;
            this.agent.rows = data.detail.count;
          }
        });
    },
    onDeleteModalAgent(data) {
      this.flag = "agent";
      this.bodyDelete.userId = data.userId;
      this.bodyDelete.platformconfigId = null;
      this.bodyDelete.teamAutoAssignId = data.teamAutoAssignId;
      this.modalMsgDelete = `${this.$t("confirmDelete2")} ${
        data.name
      } ${this.$t("yesOrNo")}`;
      this.$refs.ModalAlertConfirm.show();
    },
    onDeleteModalChannel(data) {
      this.flag = "channel";
      this.bodyDelete.userId = "";
      this.bodyDelete.platformconfigId = data.platformconfigId;
      this.bodyDelete.teamAutoAssignId = data.teamAutoAssignId;
      this.modalMsgDelete = `${this.$t("confirmDelete2")} ${
        data.name
      } ${this.$t("yesOrNo")}`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.form.id) {
        if (
          this.$v.form.$error ||
          // this.$v.agent.items.$error ||
          this.$v.channel.items.$error
        ) {
          return;
        }
      } else {
        if (this.$v.form.$error) {
          return;
        }
      }

      this.isDisabled = true;
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(`${this.$baseUrl}/TeamAssign/CreateUpdate`, this.form)
        .then((data) => {
          if (data.result == 1) {
            if (this.form.id) {
              this.handleSuccess(data.message);
            } else {
              this.$router
                .push({ path: `/assign-by-team/${data.detail}` })
                .catch(() => {});
            }
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },
    async handleSuccess(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT", { isShow: true, msg: msg });
      this.$router.push({ path: `/assign-by-team` }).catch(() => {});
    },
    async handleFail(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
        isShow: true,
        msg: msg,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-add {
  position: absolute;
  top: 10px;
  right: 15px;
}
.main-theme .tabs .tab-pane.active > div {
  min-height: 235px !important;
}
</style>
